import {
  FETCH_PREVIOUS_ORDERS,
  FETCH_PREVIOUS_ORDERS_SUCCESS,
  FETCH_PREVIOUS_ORDERS_ERROR,
  INVALIDATE_MOST_RECENT_ORDER,
} from './types';
import { GET_PREVIOUS_ORDERS } from '../../../universal/gql-operation-ids';
import { localeTagSelector } from 'shared/app/state/selectors/locales';
import { selectedStoreSelector } from 'shared/app/state/selectors/ordering';
import { getShortStoreNumber } from 'shared/app/bundles/menu/util/get-filter-query';
import { API_PROXY_V1 } from 'shared/app/utils/create-gql-fetcher';

import { getDemystifyPreviousFeatureFlag } from 'shared/app/utils/feature-flags';

export const newPreviousOrdersLimit = 40;
export const previousOrdersLimit = 10;

export const fetchPreviousOrders =
  () =>
  async (dispatch, getState, { gqlFetch }) => {
    const state = getState();

    const {
      ownershipTypeCode,
      timeZone: storeTimeZone,
      storeNumber: selectedStoreNumber,
      address,
    } = selectedStoreSelector(state)?.store || {};
    const locale = localeTagSelector(state);
    const storeNumber = getShortStoreNumber(selectedStoreNumber);
    const timeZone = storeTimeZone?.timeZoneId;
    const countryCode = address?.countryCode;

    dispatch({ type: FETCH_PREVIOUS_ORDERS, payload: { locale, storeNumber } });

    const { isFeatureFlagEnabled: isDemystifyPreviousEnabled } =
      await getDemystifyPreviousFeatureFlag();

    const storePricingInput =
      timeZone || ownershipTypeCode || countryCode
        ? {
            timeZone,
            ownershipTypeCode,
            countryCode,
          }
        : null;

    const variables = {
      locale,
      storeNumber,
      limit: isDemystifyPreviousEnabled
        ? newPreviousOrdersLimit
        : previousOrdersLimit,
      storePricingInput,
      isPricingEnabled: isDemystifyPreviousEnabled || false,
    };

    return gqlFetch({
      operationId: GET_PREVIOUS_ORDERS,
      allowNonFatalErrors: true, // Display good portion of result
      variables,
      destinationType: API_PROXY_V1,
    })
      .then((payload) => {
        dispatch({
          type: FETCH_PREVIOUS_ORDERS_SUCCESS,
          payload: payload.previousOrders,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_PREVIOUS_ORDERS_ERROR, error });
      });
  };

export const invalidateMostRecentOrder = () => (dispatch) => {
  dispatch({ type: INVALIDATE_MOST_RECENT_ORDER });
};
